import { useEffect, useMemo } from "react";
import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { ShowAlert, showConfirmationDialog } from "../../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const cols: string[] = ["#", "Name", "Actions"];

const CategoryListing = observer(() => {
  const { categoryStore } = useStores();
  const { categories, fetchCategories, setEditCategory, deleteCategory } =
    categoryStore;

  useEffect(() => {
    fetchCategories();
  }, []);

  const categoriesList = useMemo(() => {
    return categories;
  }, [categories]);

  const handleDelete = (categoryId: number) => {
    showConfirmationDialog(() => {
      deleteCategory(categoryId, (res: boolean) => {
        if (res) {
          ShowAlert.Success("Category deleted successfully.");
          fetchCategories();
        } else ShowAlert.Error("Request failed. Please try again.");
      });
    });
  };

  return (
    <table className="table table-responsive table-striped shadow-lg">
      <thead>
        <tr>
          {cols.map((c, i) => (
            <th
              scope="col"
              className="border-top-0 border-start-0 border-end-0 border-3 border-warning"
              key={i}
            >
              {c}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {categoriesList?.map((category, i) => {
          return (
            <tr key={i}>
              <th scope="row">{i + 1}</th>
              <td>{category.name}</td>

              <td>
                <div className="btn-group">
                  <button
                    className="btn"
                    onClick={() => setEditCategory(category)}
                  >
                    <FontAwesomeIcon icon={faEdit} className="text-primary" />
                  </button>
                  <button
                    className="btn"
                    onClick={() => handleDelete(category.id)}
                  >
                    <FontAwesomeIcon icon={faTrash} className="text-danger" />
                  </button>
                </div>
              </td>
            </tr>
          );
        })}
        {!categoriesList?.length && (
          <tr>
            <th colSpan={5} className="text-center">
              No data available.
            </th>
          </tr>
        )}
      </tbody>
    </table>
  );
});

export default CategoryListing;
